import { ViewBasicInterface } from 'pf-frontend-common/src/module/view/basic.interface';
import { ViewOptionsInterface } from 'pf-frontend-common/src/module/view/options.interface';

import { ContentGroupViewEvent } from 'common/module/content-group/view.event';
import { ClientPageTabViewEvent } from 'desktop/module/client/page/tab/view.event';
import { ClientPageTabViewInterface } from 'desktop/module/client/page/tab/view.interface';
import { ClientPageViewInterface } from 'desktop/module/client/page/view.interface';

export class ClientPageTabDecorator<O extends ViewOptionsInterface> implements ViewBasicInterface {
  /**
   * Main HTML element
   */
  protected element: HTMLElement;

  /**
   * Constructor
   */
  constructor(
    protected name: string,
    protected tabView: ClientPageTabViewInterface,
    protected clientPage: ClientPageViewInterface
  ) {}

  /**
   * @inheritDoc
   */
  public initialize(options: O): void {
    if (!options.element) {
      return;
    }

    // Keep HTML element
    this.element = options.element;

    this.tabView.initialize(options);
    this.tabView.setActivated(this.clientPage.getTabView().getActiveSections()[this.name]);

    // Attach observers
    this.observers();
  }

  /**
   * @inheritDoc
   */
  public render(): void {
    if (!this.element) {
      return;
    }

    this.tabView.render();
  }

  /**
   * Attach observers
   */
  private observers(): void {
    this.tabView.getEventEmitter().addListener(ClientPageTabViewEvent.update, this.onUpdateTab);

    this.clientPage.getTabView().getEventEmitter().addListener(ContentGroupViewEvent.activate, this.onActivateTabView);

    this.clientPage
      .getTabView()
      .getEventEmitter()
      .addListener(ContentGroupViewEvent.clickContentGroupButton, this.onClickContentGroupButton);
  }

  /**
   * Updated tab
   */
  private onUpdateTab = (): void => {
    this.clientPage.scrollToTab();
  };

  /**
   * Activated tab
   */
  private onActivateTabView = (name: string): void => {
    if (name === this.name) {
      this.tabView.setActivated(true);

      return;
    }

    this.tabView.setActivated(false);
  };

  /**
   * Click on tab
   */
  private onClickContentGroupButton = () => {
    this.clientPage.scrollToTab();
  };
}
